module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan3-2-6134a584812cf7e4642d3432be4d2353.webp";